import "./iconLink.css";
import { Link } from "react-router-dom";

const IconLink = ({ icon, to, size, text }) => {
  return (
    <Link
      className={"icon-link" + (text ? "" : " icon-link-no-subheading")}
      to={to}
      style={{ width: size, height: size }}
    >
      {icon}
      {text ? <span class="icon-link-subheading">{text}</span> : null}
    </Link>
  );
};

export { IconLink };
